import { dataFormat } from 'helper';
import { Lead } from './LeadGenInterface';

export const getStepSpecificData = (stepKey: string, formData: any, widgetData: any, isSubmit = true): Lead => {
  const values = formData;

  switch (stepKey) {
    case 'PersonalInfoStep': {
      const {
        firstName,
        lastName,
        email,
        phone,
        leadgen_address_country,
        leadgen_address_postal,
        leadgen_address_lookupStreetName,
        leadgen_address_lookupStreetNumber,
        leadgen_address_city,
        leadgen_address_province,
      } = values;

      return {
        firstName,
        lastName,
        email,
        phone,
        leadSourceId: widgetData?.leadSourceId,
        isSubmit,
        country: leadgen_address_country,
        zipCode: widgetData?.zipCode || leadgen_address_postal,
        originalZipCode: leadgen_address_postal,
        streetName: leadgen_address_lookupStreetName,
        addressNumber: leadgen_address_lookupStreetNumber,
        city: leadgen_address_city,
        province: leadgen_address_province,
        leadDetails: {
          'IP Address': values.IPv4,
          'Utm ClickID': values.gclickid,
          utm_source: values.utm_source,
          utm_ad: values.utm_ad,
          utm_adset: values.utm_adset,
          utm_campaign: values.utm_campaign,
        },
        adfDistributionList: widgetData?.adfDistributionList?.join(',') || '',
      };
    }

    case 'VehicleSelectionStep':
      return {
        leadSourceId: widgetData?.leadSourceId,
        isSubmit,
        leadDetails: {
          'Vehicle Type': values.vehicleType,
        },
      };

    case 'BudgetSelectionStep':
      return {
        leadSourceId: widgetData?.leadSourceId,
        isSubmit,
        leadDetails: {
          Budget: values.budget,
        },
      };

    case 'CreditScoreSelectionStep':
      return {
        leadSourceId: widgetData?.leadSourceId,
        isSubmit,
        leadDetails: {
          'Estimated Credit Rating': values.estimatedCreditRating,
        },
      };

    case 'EmploymentStatusStep':
      return {
        leadSourceId: widgetData?.leadSourceId,
        isSubmit,
        leadDetails: {
          'Employment Status': values.employmentStatus,
          'Income Source': values.employmentStatus === 'Other' ? values.incomeSource : undefined,
          'Working While In School': values.employmentStatus === 'Student' ? values.workingWhileInSchool : undefined,
        },
      };

    case 'TaxDeductionStep':
      return {
        leadSourceId: widgetData?.leadSourceId,
        isSubmit,
        leadDetails: {
          'Income Per Month Before Tax': parseInt(values.incomePerMonthBeforeTax),
          'Total Monthly Income': parseInt(values.incomePerMonthBeforeTax),
        },
      };

    case 'SecondSourceOfIncomeStep': {
      const leadDetails: Record<string, any> = {
        'Second Source Income': values.secondSourceIncome,
      };
      if (values.secondSourceIncome === 'yes') {
        leadDetails['Second Source Income Value'] = values.secondSourceIncomeValue;
      }
      return {
        leadSourceId: widgetData?.leadSourceId,
        isSubmit,
        leadDetails,
      };
    }

    case 'YearsOfIncomeStep':
      return {
        leadSourceId: widgetData?.leadSourceId,
        isSubmit,
        leadDetails: {
          'Years Ago Started Receiving Income': values.yearsAgoStartedReceivingIncome,
          'Months Ago Started Receiving Income': values.monthsAgoStartedReceivingIncome,
        },
      };

    case 'WorkInfoStep':
      return {
        leadSourceId: widgetData?.leadSourceId,
        isSubmit,
        leadDetails: {
          'Current Employer Name': values.currentEmployerName,
          'Job Title': values.jobTitle,
        },
      };

    case 'AddressStep': {
      const {
        city,
        country,
        postalCode,
        province,
        streetAddress,
        manualStreetNumber,
        manualStreetAddress,
        streetAddress_province,
        streetAddress_postalCode,
        streetAddress_country,
        streetAddress_code,
        streetAddress_selectedAddress,
        streetAddress_city,
        streetAddress_postal,
        streetAddress_lookupStreetName,
        streetAddress_lookupStreetNumber,
      } = values;

      const commonAddressData: Partial<Lead['leadDetails']> = {
        City: city || streetAddress_city,
        'Postal Code': postalCode || streetAddress_postalCode,
        Province: province || streetAddress_province,
        'Street Address': manualStreetAddress ? manualStreetAddress : streetAddress?.label,
      };

      if (manualStreetAddress) {
        return {
          province,
          zipCode: widgetData?.zipCode || postalCode,
          originalZipCode: postalCode,
          country,
          city,
          streetName: manualStreetAddress,
          addressNumber: manualStreetNumber,
          leadSourceId: widgetData?.leadSourceId,
          isSubmit,
          leadDetails: commonAddressData,
        };
      } else {
        return {
          isSubmit,
          province: streetAddress_province,
          zipCode: widgetData?.zipCode || streetAddress_postal,
          originalZipCode: streetAddress_postal,
          country: streetAddress_country,
          leadSourceId: widgetData?.leadSourceId,
          streetName: streetAddress_lookupStreetName,
          addressNumber: streetAddress_lookupStreetNumber,
          city: streetAddress_city,
          leadDetails: {
            ...commonAddressData,
            Code: streetAddress_code,
            Country: streetAddress_country,
            'Selected Address': streetAddress_selectedAddress,
          },
        };
      }
    }

    case 'YearsOfLivedStep':
      return {
        leadSourceId: widgetData?.leadSourceId,
        isSubmit,
        leadDetails: {
          'Years Lived There': values.yearsLivedThere,
          'Months Lived There': values.monthsLivedThere,
        },
      };

    case 'RentOrOwnStep':
      return {
        leadSourceId: widgetData?.leadSourceId,
        isSubmit,
        leadDetails: {
          'Rent Or Own': values.rentOrOwn,
          'Monthly House Payment': parseInt(values.monthlyHousePayment),
        },
      };

    case 'DobStep':
      return {
        birthDate: dataFormat(values.dateOfBirth, 'yyyy-MM-dd'),
        leadSourceId: widgetData?.leadSourceId,
        isSubmit,
        leadDetails: {
          'Date Of Birth': dataFormat(values.dateOfBirth, 'yyyy-MM-dd'),
        },
      };

    default:
      console.warn(`Unhandled step key: ${stepKey}`);
      return {
        leadSourceId: widgetData?.leadSourceId,
        isSubmit,
        leadDetails: {},
      };
  }
};
